const openinghours = [
  {
    size: "",
    style: "",
    class: "",
    children: [
      {
        type: "topbar",
        size: "12",
        style: "",
        class: "px-4",
        title: "Opening Hours",
      },
      {
        type: "tabs",
        size: "12",
        style: "",
        class: "px-4 pt-4",
        children: [
          {
            title: "Practice Closure",
            service: "pages",
            type: "",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: true,
              activeToggle: false,
              deleteButton: true,
              addNewSuccessTitle: "Topic Added!",
              addNewSuccessMessage: "Topic Added Successfully!",
              addNewErrorTitle: "Topic Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Topic Deleted!",
              deleteSuccessMessage: "Topic Deleted Successfully!",
              deleteErrorTitle: "Topic Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Topic Activated!",
              activeSuccessMessage: "Topic Activated Successfully!",
              activeErrorTitle: "Topic Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Topic Updated!",
              updateSuccessMessage: "Topic Updated Successfully!",
              updateErrorTitle: "Topic Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New Holiday",
                variant: "add",
                submit_url: "/api/categories/$currentCategoryId/pages",
                form: {
                  title: {
                    type: "date",
                    label: "Select Date",
                    placeholder: "Add New Holiday",
                    required: true,
                    info: true,
                    character_count: 250,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                  location_id: {
                    type: "locationSelect",
                    label: "Select Location",
                    additionalProp1: true,
                    // "inside": ['additionalProp1'],
                    placeholder: "Select Location",
                    load_url: "",
                    required: true,
                    info: true,
                    character_count: 0,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                },
                additionalProps: {
                  reduced_hours: false,
                  opening_time: "",
                  closing_time: "",
                  second_opening_time: "",
                  second_closing_time: "",
                  location_id: "",
                  status: [
                    { name: "Closed", value: true },
                    { name: "Interim Closure", value: false },
                  ],
                },
              },
            },
            children: [
              {
                type: "practiceClosureTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Dates",
                  variant: "filtered",
                  info: true,
                  size: "4",
                  style: "",
                  class: "p-0 pt-3 pr-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  filter: "locations",
                  filterOn: "location_id",
                  children: [],
                },
                form: {
                  title: "Tab Two",
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  submit_url: "/api/pages/$currentPageId",
                  form: {
                    title: {
                      type: "date",
                      label: "Date",
                      placeholder: "",
                      required: true,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    reduced_hours: {
                      type: "toggle",
                      label: "Reduced Hours",
                      placeholder: "Select Reduced Hours",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    // "reduced_hours": {
                    //     "type": 'toggle',
                    //     "label": 'Reduced Hours',
                    //     "placeholder": 'Enter Reduced Hours',
                    //     "required": false,
                    //     "info": true,
                    //     "character_count": 0,
                    //     "disabled": false,
                    //     "class": '',
                    //     "size": "12",
                    //     "style": ""
                    // },
                    status: {
                      type: "checkObject",
                      label: "Status",
                      placeholder: "Select Status",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                      options: [
                        {
                          name: "Closed",
                          value: true,
                        },
                        {
                          name: "Interim Closure",
                          value: true,
                        },
                      ],
                    },
                    opening_time: {
                      type: "time",
                      label: "Opening Time",
                      disableOn: "status",
                      disableOnValue: '{"name":"Closed","value":true}',
                      placeholder: "",
                      required: true,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    closing_time: {
                      type: "time",
                      label: "Closing Time",
                      disableOn: "status",
                      disableOnValue: '{"name":"Closed","value":true}',
                      placeholder: "",
                      required: true,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    second_opening_time: {
                      type: "time",
                      label: "Second Opening Time",
                      displayOn: "status",
                      displayOnValue: '{"name":"Interim Closure","value":true}',
                      disableOn: "status",
                      disableOnValue: '{"name":"Closed","value":true}',
                      placeholder: "",
                      required: true,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    second_closing_time: {
                      type: "time",
                      label: "Second Closing Time",
                      displayOn: "status",
                      displayOnValue: '{"name":"Interim Closure","value":true}',
                      disableOn: "status",
                      disableOnValue: '{"name":"Closed","value":true}',
                      placeholder: "",
                      required: true,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
          {
            title: "Regular Hours",
            service: "locationHours",
            type: "",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: false,
              activeToggle: false,
              deleteButton: false,
              addNewSuccessTitle: "Group Added!",
              addNewSuccessMessage: "Group Added Successfully!",
              addNewErrorTitle: "Group Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Group Deleted!",
              deleteSuccessMessage: "Group Deleted Successfully!",
              deleteErrorTitle: "Group Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Group Activated!",
              activeSuccessMessage: "Group Activated Successfully!",
              activeErrorTitle: "Group Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Regular Hours Updated!",
              updateSuccessMessage: "Regular Hours Updated Successfully!",
              updateErrorTitle: "Regular Hours Updation Failed!",
              updateErrorMessage: "Please try again!",
              addNewModal: {
                title: "Add New Group",
                variant: "add",
                form: {
                  title: {
                    type: "text",
                    label: "Group Name",
                    placeholder: "Enter Group Name",
                    required: true,
                    info: true,
                    character_count: 250,
                    disabled: false,
                    class: "",
                    size: "12",
                    style: "",
                  },
                },
                additionalProps: {
                  active: true,
                  subgroups: [],
                },
              },
            },
            children: [
              {
                type: "regularHoursTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  label: "Days",
                  type: "list",
                  // "variant": 'filtered2',
                  variant: "regularHoursFilteredList",
                  info: true,
                  size: "4",
                  style: "",
                  class: "p-0 pt-3 pr-3",
                  load_url: "/api/categories/$currentCategoryId/pages",
                  draggable: true,
                  filter: "locations",
                  filterOn: "location_id",
                  children: [],
                },
                form: {
                  title: "Tab Two",
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  submit_url: "/api/pages/$currentPageId",
                  form: {
                    status: {
                      type: "checkObject",
                      label: "Status",
                      placeholder: "Select Status",
                      required: false,
                      info: true,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                      options: [
                        {
                          name: "Closed",
                          value: true,
                        },
                        {
                          name: "Interim Closure",
                          value: true,
                        },
                      ],
                    },
                    opening_time: {
                      type: "time",
                      label: "Opening Time",
                      disableOn: "status",
                      disableOnValue: '{"name":"Closed","value":true}',
                      placeholder: "",
                      required: true,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    closing_time: {
                      type: "time",
                      label: "Closing Time",
                      disableOn: "status",
                      disableOnValue: '{"name":"Closed","value":true}',
                      placeholder: "",
                      required: true,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    second_opening_time: {
                      type: "time",
                      label: "Second Opening Time",
                      displayOn: "status",
                      displayOnValue: '{"name":"Interim Closure","value":true}',
                      disableOn: "status",
                      disableOnValue: '{"name":"Closed","value":true}',
                      placeholder: "",
                      required: true,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                    second_closing_time: {
                      type: "time",
                      label: "Second Closing Time",
                      displayOn: "status",
                      displayOnValue: '{"name":"Interim Closure","value":true}',
                      disableOn: "status",
                      disableOnValue: '{"name":"Closed","value":true}',
                      placeholder: "",
                      required: true,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
          {
            title: "Settings",
            service: "category",
            type: "",
            size: "",
            style: "",
            class: "flex",
            topbarControls: {
              addNewButton: false,
              activeToggle: false,
              deleteButton: false,
              addNewSuccessTitle: "Category Added!",
              addNewSuccessMessage: "Category Added Successfully!",
              addNewErrorTitle: "Category Creation Failed!",
              addNewErrorMessage: "Please try again!",
              deleteSuccessTitle: "Category Deleted!",
              deleteSuccessMessage: "Category Deleted Successfully!",
              deleteErrorTitle: "Category Deletion Failed!",
              deleteErrorMessage: "Please try again!",
              activeSuccessTitle: "Category Activated!",
              activeSuccessMessage: "Category Activated Successfully!",
              activeErrorTitle: "Category Activation Failed!",
              activeErrorMessage: "Please try again!",
              updateSuccessTitle: "Category Updated!",
              updateSuccessMessage: "Category Updated Successfully!",
              updateErrorTitle: "Category Updation Failed!",
              updateErrorMessage: "Please try again!",
            },
            children: [
              {
                type: "descriptionTab",
                size: "12",
                style: "",
                class: "p-0 d-flex",
                list: {
                  type: "list",
                  size: "4",
                  style: "",
                  class: "p-2",
                  empty: true,
                  children: [],
                },
                form: {
                  type: "form",
                  variant: "patch",
                  size: "8",
                  style:
                    "margin-top: -4rem; border-left: 1px solid #DADCE3; min-height: calc(100vh - 144px)",
                  class: "pl-4 pt-3",
                  load_url: "/api/cms/$currentCmsId/categories",
                  submit_url:
                    "/api/cms/$currentCmsId/categories?where=%7B%22id%22%3A%22$currentCategoryId%22%7D",
                  form: {
                    time_format: {
                      type: "radioObject",
                      label: "Time Format",
                      placeholder: "",
                      required: false,
                      info: false,
                      character_count: 0,
                      disabled: false,
                      class: "",
                      size: "6",
                      style: "",
                      options: [
                        {
                          name: "12 hour",
                        },
                        {
                          name: "24 hour",
                        },
                      ],
                    },
                    hr1: {
                      type: "hr",
                      size: "12",
                    },
                    text: {
                      inside: ["additionalProp1", "description", "text"],
                      type: "ckeditor",
                      label: "Page Description",
                      placeholder: "Enter Description",
                      required: false,
                      info: true,
                      character_count: 1000,
                      disabled: false,
                      class: "",
                      size: "12",
                      style: "",
                    },
                  },
                  children: [],
                },
              },
            ],
          },
        ],
      },
    ],
  },
];

export { openinghours };
